import script from "./facet-search-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./facet-search-dropdown.vue?vue&type=script&setup=true&lang=ts"

import "./facet-search-dropdown.vue?vue&type=style&index=0&id=26e75776&lang=scss"

const __exports__ = script;

export default __exports__